// src/pages/customer/BlogsPage.jsx
import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import { Container } from 'react-bootstrap';
import { FiSearch } from 'react-icons/fi';
import MyNavbar from '../../../components/general/mynavbar/MyNavbar';
import PageBanner from '../../../components/customer/pagebanner/PageBanner';
import BlogCard from '../../../components/customer/blogsinglecard/BlogSingleCard';
import Pagination from '../../../components/customer/pagination/Pagination';
import AppContext from '../../../contexts/AppContext';     
import '../../../assets/css/customer/screens/Blog.css';

const BlogsPage = () => {
  const { baseUrl, baseUrlForFiles } = useContext(AppContext); 

  const [blogs, setBlogs] = useState([]);                 
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [currentPage, setCurrentPage] = useState(1);

  const blogsPerPage = 6;
  const categories = ['All', 'Trending', 'CraftHive'];

  const viewAllBlogs = () => {
    axios
      .get(`${baseUrl}/customer/blogs/viewallblogs`)
      .then((response) => {
        console.log(response.data);
        setBlogs(response.data.blogs);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    viewAllBlogs();
  }, []);

  // Filter blogs
  const filteredBlogs = blogs.filter(blog => {
    const matchesSearch =
      blog.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      blog.description.toLowerCase().includes(searchTerm.toLowerCase());

    const matchesCategory = selectedCategory === 'All' || blog.category === selectedCategory;

    return matchesSearch && matchesCategory;
  });

  // Pagination
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  // Handlers
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    setCurrentPage(1);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1);
  };

  return (
    <>
      <MyNavbar />
      <div className="blogs-page">
        <PageBanner
          title="Blogs"
          subtitle="Discover stories, tips, and insights from the world of handmade crafts"
          breadcrumbs={[{ label: 'Blogs' }]}
        />

        <Container fluid className="blogs-container">
          {/* Search and Filter Toolbar */}
          <div className="blogs-toolbar">
            <div className="blogs-search">
              <FiSearch size={18} />
              <input
                type="text"
                placeholder="Search blogs..."
                value={searchTerm}
                onChange={handleSearchChange}
              />
            </div>
            <div className="blogs-categories">
              {categories.map(cat => (
                <button
                  key={cat}
                  className={`category-btn ${selectedCategory === cat ? 'active' : ''}`}
                  onClick={() => handleCategoryChange(cat)}
                >
                  {cat}
                </button>
              ))}
            </div>
          </div>

          {/* Blogs Grid */}
          <div className="blogs-grid">
            {currentBlogs.map(blog => (
              <BlogCard
                key={blog.id}
                blog={{ ...blog, image: `${baseUrlForFiles}/${blog.blogimage}` }} // ✅ image fix
                variant="home"
              />
            ))}
          </div>

          {/* No Blogs Message */}
          {filteredBlogs.length === 0 && (
            <div className="no-blogs">
              <h3>No blogs found</h3>
              <p>Try adjusting your search or category filter</p>
            </div>
          )}

          {/* Pagination */}
          {filteredBlogs.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              setCurrentPage={setCurrentPage}
            />
          )}
        </Container>
      </div>
    </>
  );
};

export default BlogsPage;